import { graphql, useStaticQuery } from 'gatsby';
import React, { FunctionComponent, useMemo } from 'react';
import Helmet from 'react-helmet';

interface SEOProps {
  title: string;
}

const SEO: FunctionComponent<SEOProps> = ({ title }) => {
  const data = useStaticQuery(graphql`
    query SeoQuery {
      sanityHomePage {
        metaDescription
      }
    }
  `);

  const description = useMemo(() => data.sanityHomePage.metaDescription, [
    data,
  ]);

  return (
    <Helmet
      htmlAttributes={{
        lang: 'en',
      }}
      title={title}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: description,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: `og:image`,
          content: 'https://adeus.vercel.app/adeus_meta.jpg',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: '@adeusfilms',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: description,
        },
        {
          name: `twitter:image`,
          content: 'https://adeus.vercel.app/adeus_meta.jpg',
        },
      ]}
    />
  );
};

export default SEO;
